<script setup lang="ts">
import { useWordProcessorStore } from "../useWordProcessorStore";

const wordProcessorInstanceId = inject("instanceId") as string;
const wordProcessorStore = useWordProcessorStore(wordProcessorInstanceId);
const { selectionRange } = storeToRefs(wordProcessorStore);
const editorRef = inject("quillEditor") as any;

const setHangingIndent = () => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return;
  const range = quill.getSelection(true);
  if (!range) return;

  if (doesSelectionHaveHangingIndent.value == true) {
    quill.format("hangingIndent", undefined);
  } else {
    quill.format("hangingIndent", "1");
  }
};

const doesSelectionHaveHangingIndent = computed(() => {
  if (selectionRange.value == undefined) return false;

  let quill = editorRef.value?.getQuill?.();
  if (!quill) return false;

  const format = quill.getFormat(
    selectionRange.value.index,
    selectionRange.value.length
  );

  return format.hangingIndent != undefined;
});
</script>

<template>
  <BaseIconButton
    @click="setHangingIndent()"
    v-tooltip="'Hanging Indent'"
    :class="{
      'bg-primary/20 text-primary': doesSelectionHaveHangingIndent,
      '!text-dark': doesSelectionHaveHangingIndent != true,
    }"
  >
    <icon name="lucide:list-tree" size="18" />
  </BaseIconButton>
</template>

<style scoped></style>
